import React, { useEffect, useState } from 'react'
import { Horizontal, Vertical } from '@gravitate-js/excalibrr'
import { IntradayGrid } from './Grid/Intraday/IntradayGrid'
import { IntradayDirectiveStatus } from './DirectiveStatus/Intraday/IntradayDirectiveStatus'
import { useDirectiveContext } from './DirectiveContext'
import api from '@utils/api'
import { OrderModal } from '../../OrderWizard/OrderModal'
import { DirectivesPage } from './DirectivesPage'
import { filterDirectives, grabFilterOptions, insertRow, sortDirectives } from './util'
import { PlannedSwitch } from './DefaultDirectiveFilters'
import { useCancelRequest } from '@components/_SiteWide/API/useCancelRequest'

export const IntradayPage = () => {
  const [isDailyLoading, setIsDailyLoading] = useState(true)
  const [showingModal, setShowingModal] = useState()
  const [unfilteredDirectives, setUnfilteredDirectives] = useState([])
  const [dailyDirectives, setDailyDirectives] = useState([])
  const [selectedOrderId, setSelectedOrderId] = useState()
  const [activeSort, setActiveSort] = useState()
  const [sortDirection, setSortDirection] = useState()
  const { setServerParams, clearState, selectedDate, filters, viewingPlanned, setRowCount } = useDirectiveContext()
  const { getCancelToken } = useCancelRequest()
  const showModal = (orderId) => {
    setSelectedOrderId(orderId)
    setShowingModal(true)
  }

  const closeModal = () => {
    setShowingModal(false)
    setSelectedOrderId(undefined)
  }

  useEffect(() => {
    clearState()
    setIsDailyLoading(true)
    const cancelToken = getCancelToken()
    api
      .getDailyDirectives(selectedDate?.toISOString(), cancelToken)
      .then((resp) => {
        setIsDailyLoading(false)
        setServerParams(grabFilterOptions(resp.data.rows, resp.data))
        setUnfilteredDirectives(resp.data.rows)
        let filteredAndSorted = [...resp.data.rows]
        if (filters) {
          filteredAndSorted = filterDirectives(filters, filteredAndSorted, viewingPlanned)
        }
        if (activeSort) {
          filteredAndSorted = sortDirectives(filteredAndSorted, activeSort, sortDirection)
        }
        setDailyDirectives(filteredAndSorted)
        setRowCount(filteredAndSorted.length)
      })
      .catch(() => console.log('cancelled'))
  }, [selectedDate])

  useEffect(() => {
    if (!filters) {
      return
    }
    const filtered = filterDirectives(filters, unfilteredDirectives, viewingPlanned)
    setDailyDirectives(filtered)
    setRowCount(filtered.length)
  }, [filters, isDailyLoading])
  useEffect(() => {
    if (!activeSort) {
      return
    }
    const sorted = sortDirectives(dailyDirectives, activeSort, sortDirection)
    setDailyDirectives(sorted)
    setRowCount(sorted.length)
  }, [activeSort, sortDirection])
  const addPricesToRow = (directive, prices) => {
    const updatedRow = { ...directive, prices: prices }
    insertRow(updatedRow, unfilteredDirectives, dailyDirectives, setUnfilteredDirectives, setDailyDirectives)
  }
  return (
    <DirectivesPage SwitchComponent={<PlannedSwitch />}>
      <OrderModal showingModal={showingModal} closeModal={closeModal} selectedOrder={selectedOrderId} />
      <Horizontal fullHeight className=' my-2'>
        <Vertical flex={4}>
          <IntradayGrid
            activeSort={activeSort}
            sortDirection={sortDirection}
            setActiveSort={setActiveSort}
            setSortDirection={setSortDirection}
            isDailyLoading={isDailyLoading}
            dailyDirectives={dailyDirectives}
            addPricesToRow={addPricesToRow}
          />
        </Vertical>
        <Vertical flex={3}>
          <IntradayDirectiveStatus
            showModal={showModal}
            dailyDirectives={dailyDirectives}
            isDailyLoading={isDailyLoading}
          />
        </Vertical>
      </Horizontal>
    </DirectivesPage>
  )
}
